<template>
  <div class="container">
  <div class="home-banner">
    <img class="banner-bg" src="@/assets/lianxiwom.png" alt="">
    <div class="textBox typeArea">
      <p class="centerBanner animated zoomIn">联系我们</p>
    </div>
  </div>
  <div class="ow-box">
    <div class="ow-mode">
      <div class="ow-cont">
        <div style="padding-bottom: 89px;"></div>
        <div class="cont-title">
          商务咨询
        </div>
        <div class="ow">
          <div class="ow-list">
            <ul>
              <li>
                <div class="ow-img"><img src="@/assets/youxiang.png" alt=""></div>
                <div class="ow-title">邮箱</div>
                <div class="ow-text">info@bu-dun.com</div>
              </li>
              <li>
                <div class="ow-img"><img src="@/assets/dianhua.png" alt=""></div>
                <div class="ow-title">电话</div>
                <div class="ow-text">400-699-8565</div>
              </li>
              <li>
                <div class="ow-img"><img src="@/assets/rencai.png" alt=""></div>
                <div class="ow-title">招聘</div>
                <div class="ow-text">hr@bu-dun.com</div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="ow-box">
    <div class="ow-mode">
      <div class="ow-cont">
        <div style="padding-bottom: 89px;"></div>
        <div class="cont-title">
          公司地址
        </div>
        <div class="ow-dizhi">
          <div class="dizhi-map" id="allmap">
          </div>
          <div class="dizhi-info">
            <img class="info-img" src="@/assets/beijing.png" alt="" v-if="title == '北京'">
            <img class="info-img" src="@/assets/shandong.png" alt="" v-else>
            <div class="weizhi">
              <div class="weizhi-name" @click="title = '北京'" style="background: #fff;">北京</div>
              <div class="weizhi-name" @click="title = '山东'" style="background: rgba(0, 0, 0, 0);color:#212121;">山东</div>
            </div>
            <div class="info-box beijing">
              <div class="info-title">北京部盾信息科技有限公司</div>
              <div class="info-text">北京市朝阳区东三环中路乙10号艾维克大厦2401B</div>
            </div>
            <div class="info-box shandong" style="display: none;">
              <div class="info-title">部盾信息科技有限公司(山东)</div>
              <div class="info-text">济南市章丘区圣井街道办事处府前街7号</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div style="padding-bottom: 120px;"></div>
  </div>
</div>
</template>

<script>
export default {
  name: "ContactUs",
  data() {
    return {
      title: '北京'
    };
  },
  methods: {
    ShowMap(zuobiao, name, addrsee, phone, chuanzhen, zoom) {
      var arrzuobiao = zuobiao.split(',');
      var map = new BMap.Map("allmap");
      map.centerAndZoom(new BMap.Point(arrzuobiao[0], arrzuobiao[1]), zoom);
      map.addControl(new BMap.NavigationControl());
      var marker = new BMap.Marker(new BMap.Point(arrzuobiao[0], arrzuobiao[1]));
      map.addOverlay(marker);
      var infoWindow = new BMap.InfoWindow('<p style="color: #bf0008;font-size:14px;">' + name + '</p><p>地址：' + addrsee + '</p>');
      marker.addEventListener("click", function () {
        this.openInfoWindow(infoWindow);
      });
      marker.openInfoWindow(infoWindow);
    }
  },
  mounted() {
    var vm = this
    vm.ShowMap('116.469429,39.910801', '北京部盾信息科技有限公司', '北京市朝阳区东三环中路乙10号艾维克大厦2401B', '021-888888888', '021-888888888', '20');
    $('.weizhi-name').click(function () {
      var that = this
      $('.weizhi-name').css('background', 'rgba(0, 0, 0, 0)')
      $('.weizhi-name').css('color', '#212121')
      $(that).css('background', '#fff')
      $(that).css('color', '#DE2726')
      if ($(that).text() == '北京') {
        $('.beijing').css('display', 'block');
        $('.shandong').css('display', 'none');
        vm.ShowMap('116.469429,39.910801', '北京部盾信息科技有限公司', '北京市朝阳区东三环中路乙10号艾维克大厦2401B', '021-888888888', '021-888888888', '18');
      } else {
        $('.beijing').css('display', 'none');
        $('.shandong').css('display', 'block');
        vm.ShowMap('117.438492,36.678819', '部盾信息科技有限公司(山东)', '济南市章丘区圣井街道办事处府前街7号', '021-888888888', '021-888888888', '18');
      }
    })
  },
}
</script>

<style scoped>
   
</style>